/* unplugin-vue-components disabled */import script from "./wxapp_pre_list.vue?vue&type=script&setup=true&lang=js"
export * from "./wxapp_pre_list.vue?vue&type=script&setup=true&lang=js"

import "./wxapp_pre_list.vue?vue&type=style&index=0&id=572f20b1&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-572f20b1"]])

export default __exports__